import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

export default function TaskAttachment({ task }) {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const router = useRouter();
  const isBot = !!task?.agentId;
  // `conversation` alone is the most recent result, not a persistent binding.
  const isChat = !!(task?.workSessionId || task?.workSession);
  if (!isBot && !isChat) return null;

  const conversationId = task?.conversationId || task?.conversation?.id || task?.conversation?._id
    || (typeof task?.conversation === 'string' ? task.conversation : null);
  const label = isBot
    ? t('tasks.attachedBot', { name: task.agentName || t('tasks.selectedBot') })
    : t('tasks.attachedChat', { name: task.conversationTitle || task.conversation?.title || t('tasks.untitledWorkChat') });
  const canOpen = !isBot && !!conversationId;
  const Container = canOpen ? Pressable : View;

  return (
    <Container
      style={styles.row}
      {...(canOpen ? {
        accessibilityRole: 'link',
        accessibilityLabel: label,
        onPress: event => {
          event?.stopPropagation?.();
          router.push(`/c/${conversationId}`);
        },
      } : {})}
    >
      <Icon name={isBot ? 'robot' : 'comment'} size={12} color={colors.text_color_secondary} />
      <Text size="s" color="secondary" numberOfLines={2} style={styles.label}>{label}</Text>
    </Container>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 6, maxWidth: '100%', minWidth: 0 },
  label: { flexShrink: 1 },
});
